module.exports = __webpack_public_path__ + "static/media/mobile_messenger_2x.3cb5ff6f.png";